import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ContactUsActions, SnackbarActions } from 'actionsets'
import { ConfirmationDialog } from 'components'
import Typography from '@material-ui/core/Typography'
import FormMixin from 'containers/shared/FormMixin'
import StyleSheet from 'styles'

export class Dialog extends FormMixin(Component){

  static propTypes = {
    onRequestClose: PropTypes.func.isRequired
  }

  constructor(props){
    super(props)
    ContactUsActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
  }

  get formObject(){
    return {
      title: '',
      subject: ''
    }
  }

  handleRequestClose = () =>
    this.props.onRequestClose && this.props.onRequestClose()

  handleConfirm = async () => {
    try{
      await this.actions.create(this.state.attributes)
      this.setState({attributes: {}})
      this.handleRequestClose()
      this.actions.snackbar.success('Request sent')
    }catch(_){
      this.actions.snackbar.error('Failed to send request')
    }
  }

  render() {
    const { TextField } = this
    return (
      <ConfirmationDialog
          open={!!this.props.open}
          title={"Contact Us"}
          onConfirm={this.handleConfirm}
          onCancel={this.handleRequestClose}
          canConfirm={true}>
        <Typography variant='body1'>
          Please enter your message or query here. <br/>
          It will be sent to an administrative user who will respond to you as soon as possible.
        </Typography>
        <Typography tyle='body1' style={{color: 'red', margin: 10}}>{this.props.errors.create && this.props.errors.create.message}</Typography>
        <div className={styles.dialogBody}>
          <TextField focusFirst label='Subject' attribute='title' />
          <TextField rows={10} attribute='message' label='Message'  multiline/>
        </div>
      </ConfirmationDialog>
    )
  }
}

const styles = StyleSheet({
  dialogBody: {
    padding: 5,
    '> div': {
      margin: 0
    }
  }
})
export default connect(({contactUs}) => contactUs)(Dialog)